import { apiClient, SCOPE_ID } from '@/lib/api-client';

export interface StartedImpersonation {
  sessionId: string;
  expiresAt: string;
}

/**
 * Abre a sessão de suporte sobre o usuário. A máscara só vale nas requests que
 * saem com o `x-scope-id` de destino: este painel, por padrão, ou a plataforma
 * do aluno quando a sessão vai para outra aba.
 */
export async function startImpersonationSession(
  userId: string,
  reason: string,
  scopeId: string = SCOPE_ID,
): Promise<StartedImpersonation> {
  const { data } = await apiClient.post<StartedImpersonation>(
    `/admin/identity/users/${userId}/impersonations`,
    { scopeId, reason },
  );
  return data;
}

/** Idempotente: sessão já encerrada ou vencida responde igual. */
export async function endImpersonationSession(
  sessionId: string,
): Promise<void> {
  await apiClient.post('/auth/impersonation/end', { sessionId });
}

/** Encerra as sessões abertas **por** este usuário (ele é o ator). */
export async function endAllImpersonations(
  userId: string,
): Promise<{ ended: number }> {
  const { data } = await apiClient.post<{ ended: number }>(
    `/admin/identity/users/${userId}/impersonations/end-all`,
    {},
  );
  return data;
}
